<template>
  <div style="float: left;">
    <v-btn depressed color="error" @click.prevent="modal.show = true" class="ml-2">
      Indeferir
    </v-btn>    
    <v-dialog
      v-if="modal.show"
      v-model="modal.show"
      width="400"
      persistent 
      @keydown.esc="close"
    > 
      <v-card class="mb-0">
        <v-card-title class="app-card-title">
          Confirmar Recusa 
          <v-spacer />
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="app-card-content">
          <p>
            Tem certeza que deseja recusar este pedido <strong>({{ id }})</strong>?
          </p>

          <v-form ref="form" lazy-validation>
            <v-textarea
              v-model="form.reason"
              :disabled="isLoading"
              label="Motivo da recusa*"
              :rules="[rules.required]"
              outlined
              dense
              autofocus
              placeholder="Ex:. documento vencido"
              class="mt-5"
              color="success"
            />
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            color="error"
            :disabled="isLoading"
            @click.prevent="onSubmit"
          >
            {{ isLoading ? "Processando..." : "Confirmar" }}
          </v-btn>
        </v-card-actions>
      </v-card>    
    </v-dialog>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'OrderRefusalButton',

    props: {
      id: {
        type: Number,
        required: true
      }
    },

    data: () => ({
      isLoading: false,

      modal: {
        show: false
      },

      form: {
        reason: ''
      },

      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido',
      },
    }),

    methods: {
      close(updated = false) {        
        this.modal.show = false;
        this.$emit('close', updated);
      },

      async onSubmit() {
        const isValid = this.$refs.form.validate();
        if (!isValid) return;

        await this.refuse({ id: this.id, reason: this.form.reason }); 
        this.close(true);
      },

      ...mapActions('pedido', {
        refuse: 'REFUSE',      
      }),
    }
  };
</script>